module.exports = __webpack_public_path__ + "img/202505_02.2d65d438.jpg";